import { cx } from "@/utils/classnames";
import React, { PropsWithChildren } from "react";

export interface LoginFormLiveryWrapperProps extends PropsWithChildren {
  customerLiveryFilename: string | undefined;
}

export const LoginFormLiveryWrapper: React.FC<LoginFormLiveryWrapperProps> = ({
  children,
  customerLiveryFilename,
}) => {
  return (
    <div
      className={cx(
        "w-full lg:basis-1/2 flex flex-col items-center px-4 sm:px-6 md:px-8 lg:px-10",
        "lg:items-start",
      )}
    >
      <div
        className={cx(
          "flex w-full max-w-md flex-col items-center",
          customerLiveryFilename ? "lg:mt-[calc(10vh+80px)]" : "lg:mt-[calc(15vh+80px)]",
          "lg:ml-[min(8vw,168px)]",
        )}
      >
        {customerLiveryFilename ? (
          <img
            alt={"customer-specific brand logo"}
            src={`/livery/${customerLiveryFilename}`}
            className={"max-h-[36px] h-[36px] mb-4"}
          />
        ) : null}
        {children}
      </div>
    </div>
  );
};
